import axios from 'axios';
import createBusinessCardPayload from '../utils/createBusinessCardPayload';
import groupImagesByType from '../utils/groupImagesByType';
import businessCardModel from '../models/businessCard';
import transformBusinessCard from '../utils/transformBusinessCard';

const parseBusinessCard = (businessCardToParse) => {
    const {actions,settings,clientInfo,images,status} = businessCardToParse;
    const businessCard = businessCardModel(actions,clientInfo,images,settings,status);
    const parsedBusinessCard = transformBusinessCard(businessCard);
    return parsedBusinessCard;
}

const businessCardService = {
    fetchBusinessCard(businessCardName){
        
        return axios.get(`/api/cards/${businessCardName}`)
        .then((res)=>{
            console.log(res)
            const businessCard = parseBusinessCard(res.data.data);
            return businessCard;
        })
        .catch((err) => {
            throw(err);
        });

    },
    async updateBusinessCard(businessCard,deletedActions,deletedImages){
        
        const businessCardName = businessCard.clientInfo.cardname;
        const businessName = businessCard.clientInfo.businessname;
        const payload = createBusinessCardPayload(businessName,businessCardName,businessCard,deletedActions,deletedImages);

        try{

            const result = await axios.post(`/api/cards/${businessCardName}`,payload);
            const businessCard = parseBusinessCard(result.data.data);

            return {
                success: true,
                data: businessCard
            }

        }
        catch(e){

            return {
                success: false,
                error: e
            }

        }

    },
    async createBusinessCard(businessCard){

        const businessCardName = businessCard.clientInfo.cardname;
        const businessName = businessCard.clientInfo.businessname;
        const payload = createBusinessCardPayload(businessName,businessCardName,businessCard);

        try{
            
            const result = await axios.put(`/api/cards/${businessCardName}`,payload)
            console.log(result);
            const businessCard = parseBusinessCard(result.data.data);

            return {
                success:true,
                data: businessCard
            }

        }
        catch(e){

            return {
                success: false,
                error: e
            }

        }

    }
}

export default businessCardService;